<div class="hero is-fullheight">
	<div class="hero-body" style="padding-bottom: 0">
		<div class="container has-text-centered">
			<p class="blue has-text-centered is-size-5 column is-two-thirds page-description">
				Venta de instrumentos de medición de marcas reconocidas con calibración acreditada ante EMA y trazabilidad al CENAM.
			</p>
			<div class="columns is-multiline is-mobile" style="margin-bottom: 2.5em">
				<div *ngFor="let logo of logos" class="column is-one-fifth-widescreen is-half-mobile is-one-third-tablet">
					<img [src]="'/assets/img/equipment/logos/' + logo">
				</div>
			</div>
			<app-contact-form [isEquipmentForm]="true" buttonText="Cotizar" title="Cotiza tu equipo"></app-contact-form>
		</div>
	</div>
</div>

